
    import {defineComponent, reactive} from 'vue';

    interface State {
        sealType: string;
    }

    export default defineComponent({
        name: "footerReport",
        setup() {
            let state: State = reactive({
                sealType: '',
            })
            return {
                state
            }
        },
        methods: {}
    })
